<template>
  <div>
    <div class="quranIcon" :class="lang == 'en' ? 'quranIconEN' : ''" @click="readQuran">
      <i class="fas fa-quran"></i><span> {{ $t("home.quranKarim") }} </span>
    </div>
    <v-container class="styleCotainer" elevation="0">
      <img class="imageHeader" src="@/assets/loogo-.png" :alt="$t('navbar.title')" />
      <v-row>
        <v-col cols="12" sm="6" md="3" class="bookSection searchCategry">
          <v-card color="primary" class="mb-2">
            <v-card-actions style="color: #fff; height: 44px">
              {{ $t("home.booksCategories") }}
              <v-spacer></v-spacer>
              <span>{{ AllBookCount }}</span>
            </v-card-actions>
          </v-card>
          <!-- --------------- -->
          <template>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :hide-details="true" class="rounded-0 magnifyIcon mb-2" outlined dense
                  :label="SectionOne.PlaceHoldeTextBox" v-model="SectionOne.SearchKey"
                  :readonly="SectionOne.SwitchModel == null" @keyup.enter="SectionOneSearch"
                  @click:append-outer="SectionOneSearch" background-color="#fff" append-outer-icon="mdi-magnify"
                  v-bind="SectionOne.SwitchModel == null ? attrs : ''" v-on="SectionOne.SwitchModel == null ? on : ''">
                  <template v-slot:prepend>
                    <v-menu left offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn style="height: 40px" elevation="0" v-bind="attrs" v-on="on" color="orange"
                          class="white--text rounded-0">
                          <v-icon left> mdi-chevron-down </v-icon>
                        </v-btn>
                      </template>
                      <v-card class="menuCard">
                        <v-card-text @click.stop class="pa-2">
                          <v-switch color="light-green" v-model="SectionOne.SwitchModel" inset
                            :label="$t('home.searchCategory')" hide-details="true"
                            @change="SectionOneChangeSearchMethod" class="mt-0" value="Categories"></v-switch>
                          <v-switch color="light-green" v-model="SectionOne.SwitchModel" inset
                            :label="$t('home.searchBook')" hide-details="true" @change="SectionOneChangeSearchMethod"
                            class="" value="BookName"></v-switch>
                          <v-switch color="light-green" v-model="SectionOne.SwitchModel" inset
                            :label="$t('home.searchBooksInsde')" hide-details="true"
                            @change="SectionOneChangeSearchMethod" class="" value="InsideAllBooks"></v-switch>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </template>
                </v-text-field>
              </template>
              <span>{{ $t("home.checkSearchMethot") }}</span>
            </v-tooltip>
          </template>
          <!-- --------------- -->
          <v-card :style="heghtScreen" style="border-radius: 10px !important" class="mx-auto bookList" tile>
            <v-card-text v-if="CategoriesTree.length != 0" class="px-0 py-1">
              <v-treeview class="treeview" :items="CategoriesTree" item-key="categoryid" item-children="children">
                <template v-slot:label="{ item }">
                  <div @click="GetBooksByCategory(item)">
                    <v-icon class="categryIcon"> mdi-bookshelf </v-icon>
                    <span style="font-size: 14px" :title="
                      item.translate.categorynametrans[lang] +
                      ' - ' +
                      item.books_count
                    ">
                      {{ item.translate.categorynametrans[lang] }} -
                      <label>{{ item.books_count }}</label>
                    </span>
                  </div>
                </template>
              </v-treeview>
            </v-card-text>
            <v-card-text v-else class="px-0 py-1">
              <span class="noDataText">{{ $t("home.noDataSection") }}</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="bookSection searchCategry">
          <v-card color="primary" class="mb-2">
            <v-card-actions style="color: #fff">
              {{ $t("home.booksNames") }}
              <v-spacer></v-spacer>
              <span class="mx-2" v-if="SectionOne.SelectedCategory != null">
                {{ SectionOne.SelectedCategory.books_count }}</span>
              <v-menu bottom :offset-y="true">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small color="primary" dark v-bind="attrs" v-on="on" elevation="0">
                    <v-icon> mdi-filter </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click.stop>
                    <v-switch color="light-green" v-model="SectionTwo.SortBy" inset :label="$t('home.sortByName')"
                      hide-details="true" class="mt-0" value="bookname" @change="SortBooks"></v-switch>
                  </v-list-item>
                  <v-list-item @click.stop>
                    <v-switch color="light-green" v-model="SectionTwo.SortBy" inset :label="$t('home.sortByPublish')"
                      hide-details="true" class="mt-0" value="publisheryear" @change="SortBooks"></v-switch>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-actions>
          </v-card>
          <template class="bookListCenter">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="SectionTwo.SearchKey" class="rounded-0 magnifyIcon mb-2" outlined dense
                  hide-details="false" :label="SectionTwo.PlaceHoldeTextBox" @keyup.enter="SectionTwoSearch()"
                  background-color="#fff" append-outer-icon="mdi-magnify" @click:append-outer="SectionTwoSearch()"
                  :readonly="SectionTwo.SwitchModel == null" v-bind="SectionTwo.SwitchModel == null ? attrs : ''"
                  v-on="SectionTwo.SwitchModel == null ? on : ''">
                  <template v-slot:prepend>
                    <v-menu left offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn style="height: 40px" elevation="0" v-bind="attrs" v-on="on" color="orange"
                          class="white--text rounded-0">
                          <v-icon left> mdi-chevron-down </v-icon>
                        </v-btn>
                      </template>
                      <v-card class="menuCard">
                        <v-card-text @click.stop class="pa-2">
                          <v-list-item @click.stop>
                            <v-switch color="light-green" v-model="SectionTwo.SwitchModel" inset
                              :label="$t('home.serchBookCategory')" hide-details="true" class="mt-0"
                              value="BooksInCategory" :disabled="DisableSwitchSectionTow"
                              @change="SectionTwoChangeSearchMethod"></v-switch>
                          </v-list-item>
                          <v-list-item @click.stop>
                            <v-switch color="light-green" v-model="SectionTwo.SwitchModel" inset
                              :label="$t('home.serchBookInsideAll')" hide-details="true" class="mt-0"
                              value="InsideCategory" @change="SectionTwoChangeSearchMethod"></v-switch>
                          </v-list-item>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </template>
                </v-text-field>
              </template>
              <span>{{ $t("home.checkSearchMethot") }}</span>
            </v-tooltip>
          </template>
          <v-card :style="heghtScreen" id="listBook" style="border-radius: 10px !important" class="mx-auto bookList"
            tile @scroll="LoadMoreBook(2)">
            <v-card-text v-if="SectionTwo.BooksList.length != 0" class="px-0 py-1">
              <v-list dense flat>
                <v-list-item-group color="primary">
                  <v-list-item @click="ClickBookItem(item)" v-for="(item, i) in SectionTwo.BooksList" :key="i"
                    style="    height: auto !important;">
                    <v-list-item-icon>
                      <i class="fas fa-book"></i>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-row no-gutters>
                          <v-col cols="9">
                            <p style="    white-space: break-spaces;" class="mb-0">{{ item.bookname }}
                              <b v-if="item.publisheryear != null">( {{ item.publisheryear }} هـ )</b>
                            </p>
                          </v-col>
                          <v-col cols="3">
                            <v-btn class="float-left font-weight-bold"
                              @click.stop="$router.push(`/read-book/` + item.bookid)" text small color="orange">{{
                                $t('public.bookopen')
                              }}</v-btn>

                          </v-col>
                        </v-row>


                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text v-else class="px-0 py-1">
              <span class="noDataText">{{ $t("home.noDataSection") }}</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="5" class="bookSection searchCategry">
          <v-card color="primary" class="mb-2">
            <v-card-actions style="color: #fff; min-height: 44px">
              <span v-if="BookInformation.bookname != null">
                {{ $t("home.bookNameTow") }} : {{ BookInformation.bookname }}
              </span>
            </v-card-actions>
          </v-card>
          <template>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :hide-details="true" class="rounded-0 magnifyIcon mb-2" outlined dense
                  :label="SectionThree.PlaceHoldeTextBox" v-model="SectionThree.SearchKey"
                  :readonly="SectionThree.SwitchModel == null" @keyup.enter="SectionThreeSearch()"
                  background-color="#fff" append-outer-icon="mdi-magnify" @click:append-outer="SectionThreeSearch()"
                  v-bind="SectionThree.SwitchModel == null ? attrs : ''"
                  v-on="SectionThree.SwitchModel == null ? on : ''">
                  <template v-slot:prepend>
                    <v-menu left offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn style="height: 40px" elevation="0" v-bind="attrs" v-on="on" color="orange"
                          class="white--text rounded-0">
                          <v-icon left> mdi-chevron-down </v-icon>
                        </v-btn>
                      </template>
                      <v-card class="menuCard">
                        <v-card-text @click.stop class="pa-2">
                          <v-switch color="light-green" v-model="SectionThree.SwitchModel" inset
                            :label="$t('home.serchBooksMeta')" hide-details="true"
                            @change="SectionThreeChangeSearchMethod" class="" value="BookMeta"></v-switch>
                          <v-switch color="light-green" v-model="SectionThree.SwitchModel" inset
                            :label="$t('home.serchThisBookInside')" hide-details="true"
                            @change="SectionThreeChangeSearchMethod" class="" value="InsideThisBook"></v-switch>
                          <v-switch color="light-green" v-model="SectionThree.SwitchModel" inset
                            :label="$t('home.serchThisPusher')" hide-details="true"
                            @change="SectionThreeChangeSearchMethod" class="" value="InsideAllBooksAuther"></v-switch>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </template>
                </v-text-field>
              </template>
              <span>{{ $t("home.checkSearchMethot") }}</span>
            </v-tooltip>
          </template>
          <v-card v-if="BookInformation.bookname != ''" :style="heghtScreen"
            style="border-radius: 10px; overflow: auto">
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="9">
                  <p class="my-0" style="font-size: 13px">
                    <b>{{ $t("home.bookName") }} </b>
                    <span>{{ BookInformation.bookname }}</span> -
                    <span v-if="BookInformation.author.length != 0">{{
                      BookInformation.author[0]["authorname"]
                    }}</span>
                  </p>
                  <p class="my-0" style="font-size: 13px">
                    <b>{{ $t("home.publishYear") }}</b>
                    <span v-if="BookInformation.publisher">{{
                      BookInformation.publisher[0]["publisheryear"]
                    }}</span>
                  </p>
                  <p class="my-0" style="font-size: 13px">
                    <b>{{ $t("home.publishSrc") }}</b>
                    <span v-if="BookInformation.publisher">{{
                      BookInformation.publisher[0].publishername
                    }}</span>
                    <span v-else>---</span>
                  </p>
                  <v-divider class="mt-2 mb-2 ml-2"></v-divider>
                  <p style="
                      font-size: 12px;  height: 100px;  border: 1px solid #e0e0e0;  overflow: auto;  margin-left: 10px;  border-radius: 10px;
                    " class="my-0 px-1">
                    {{ BookInformation.bookdsecription }}
                  </p>
                </v-col>
                <v-col cols="3">
                  <div class="rounded-lg" width="150">
                    <img v-if="!BookInformation.cover" class="" src="@/assets/bookCover.jpg"
                      style="width: 100%; border-radius: 5px" />
                    <img v-else class="" :src="BookInformation.cover" style="width: 100%; border-radius: 5px" />
                    <v-btn :title="
                      BookInformation.isdownloadable == true
                        ? $t('home.downloadBook')
                        : ''
                    " :disabled="!BookInformation.isdownloadable" color="#8bc34a" style="width: 100%; font-size: 12px"
                      @click="downloadBook(BookInformation)" class="DowloadBookBtn">
                      <v-icon> mdi-download-outline </v-icon>
                      <span class="textDownload">{{ $t("home.downloadBook") }}</span>
                    </v-btn>
                    <v-btn color="#ff9800"  style="width: 100%; font-size: 12px"
                      @click="readBook($router.push(`/read-book/` + BookInformation.bookid))" class="DowloadBookBtn mt-2">
                      <span class="textDownload">{{ $t("public.bookopen") }}</span>
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" class="mt-2">
                  <v-card v-if="SectionThree.BooksList.length != 0" height="210px"
                    style="overflow: auto; border-radius: 10px" @scroll="LoadMoreBook(3)" id="listBookAuther">
                    <v-card-text class="pa-0">
                      <v-list dense flat class="mt-2">
                        <v-list-item-group color="primary">
                          <v-list-item @click="ClickBookItem(item)" v-for="(item, i) in SectionThree.BooksList"
                            :key="i">
                            <v-list-item-icon>
                              <i class="fas fa-book"></i>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>
                                <v-row no-gutters>
                                  <v-col cols="9">
                                    <p style="    white-space: break-spaces;" class="mb-0">{{ item.bookname }}
                                      <b v-if="item.publisheryear != null">( {{ item.publisheryear }} هـ )</b>
                                    </p>
                                  </v-col>
                                  <v-col cols="3">
                                    <v-btn class="float-left font-weight-bold"
                                      @click.stop="$router.push(`/read-book/` + item.bookid)" text small
                                      color="orange">{{ $t('public.bookopen') }}</v-btn>

                                  </v-col>
                                </v-row>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card-text>
                  </v-card>

                  <v-card v-else>
                    <v-card-text class="px-0 py-1">
                      <span class="noDataText">{{
                        $t("home.noDataSection")
                      }}</span>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card style="border-radius: 10px" :style="heghtScreen" v-else>
            <v-card-text class="px-0 py-1">
              <span class="noDataText">{{ $t("home.noDataSection") }}</span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <OpenBook v-model="dialogData" v-if="dialogData.bookId != null" />

    <v-row justify="center">
      <v-dialog v-model="dialog" max-width="290">
        <v-card>
          <v-card-title class="text-h5">
            {{ $t("readBook.DialogOpenType") }}
          </v-card-title>

          <v-card-text>
            {{ $t("readBook.DialogOpenTypeParag") }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="
              $router.push({
                name: 'ReadBook',
                params: { bookID: dialogData.bookId },
              })
            ">
              {{ $t("readBook.OpenNewPage") }}
            </v-btn>

            <v-btn color="green darken-1" text @click="
              dialogData.dialogStatus = true;
            dialog = false;
            ">
              {{ $t("readBook.Dialog") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>


<style scoped>
@import "../assets/style/homePage.css";

.bookDetailes .v-list-item--dense,
.v-list--dense .v-list-item:nth-child(odd) {
  background: #eaeaea;
}
</style>
<script>
import axios from "axios";
import OpenBook from "@/components/Books/OpenBook";

export default {
  data() {
    return {
      dialog: false,
      dialogData: {
        dialogStatus: false,
        bookId: null,
      },
      CategoriesTree: [],
      AllBookCount: null,
      CotegoryBooksCounts: null,
      SectionOne: {
        PlaceHoldeTextBox: this.$t("home.checkSearchMethot"),
        SearchKey: "",
        SelectedCategory: null,
        SwitchModel: null,
      },

      //   ---------------
      //   ---------------
      SectionTwo: {
        SortBy: "bookname",
        SwitchModel: null,
        SearchKey: "",
        PlaceHoldeTextBox: this.$t("home.checkSearchMethot"),
        PageCount: 1,
        BooksList: [],
      },
      SectionThree: {
        PlaceHoldeTextBox: this.$t("home.checkSearchMethot"),
        SearchKey: "",
        SwitchModel: null,
        BooksList: [],
        PageCount: 1,
      },
      DisableSwitchSectionTow: false,
      BookInformation: {
        bookid: "",
        bookname: "",
        author: [],
        pusher: [],
        yaer: "",
        delay: 250,
      },

      //   ---------------
      heghtScreen: 1200,
      timer: null,
      timerClick: null,
      clicks: 0,
    };
  },
  components: {
    OpenBook,
  },
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    lang() {
      return this.$store.getters.getLang;
    },
  },
  watch: {
    "SectionOne.SearchKey": function (val) {
      if (val != "" && this.SectionOne.SwitchModel == "BookName") {
        this.DisableSwitchSectionTow = true;
        this.SectionTwo.SwitchModel = false;
        this.SectionTwo.SearchKey = "";
      } else {
        this.DisableSwitchSectionTow = false;
      }
    },
    lang: function () {
      this.SectionOneChangeSearchMethod();
      this.SectionTwoChangeSearchMethod();
      this.SectionThreeChangeSearchMethod();

    },

    "SectionOne.SwitchModel": function (val) {
      if (this.SectionOne.SearchKey != "") {
        this.SectionOne.SearchKey = "";
        this.GetCategries("");
      }
      if (val == "BookName" && this.SectionOne.SearchKey != "") {
        this.DisableSwitchSectionTow = true;
        this.SectionTwo.SwitchModel = false;
        this.SectionTwo.SearchKey = "";
      } else {
        this.DisableSwitchSectionTow = false;
      }
    },
  },
  created() {
    this.heghtScreen =
      "height:" +
      (document.documentElement.clientHeight - 200) +
      "px ; margin-bottom: 45px;";

    this.GetCategries("");
    this.getBookCount();
  },
  methods: {
    SectionOneSearch() {
      if (this.SectionOne.SwitchModel == "Categories") {
        this.GetCategries(this.SectionOne.SearchKey);
      } else if (this.SectionOne.SwitchModel == "BookName") {
        this.SectionTwo.PageCount = 1;
        this.SectionTwo.BooksList = [];
        this.GetBooks(
          "filter[bookname]=" + this.SectionOne.SearchKey,
          "NewData"
        );
      } else if (this.SectionOne.SwitchModel == "InsideAllBooks") {
        if (this.SectionOne.SearchKey.length < 4) {
          this.$store.dispatch("PushErrorMsg", this.$t('valid.fourChar'))

          return
        }
        this.$router.push({
          name: "SearchBookInside",
          query: { kay: this.SectionOne.SearchKey },
        });
      }
    },
    GetBooksByCategory(item) {
      if (this.SectionOne.SwitchModel == "BookName") {
        this.SectionOneChangeSearchMethod("Categories");
        this.SectionOne.SearchKey = "";
        this.SectionOne.SwitchModel = "Categories";
      }
      this.SectionThree.SwitchModel = "";
      this.SectionThree.PlaceHoldeTextBox = this.$t("home.checkSearchMethot");
      this.SectionTwo.SearchKey = "";
      this.SectionTwo.BooksList = [];
      this.SectionTwo.PageCount = 1;
      this.GetBooks(
        "filter[categories.categoryid]=" +
        item.categoryid +
        "&sort=" +
        this.SectionTwo.SortBy,
        "NewData"
      );
      this.SectionOne.SelectedCategory = item;
    },
    SectionOneChangeSearchMethod(value) {
      if (value == "Categories") {
        this.SectionOne.PlaceHoldeTextBox = this.$t("home.searchCategory");
      } else if (value == "BookName") {
        this.SectionOne.PlaceHoldeTextBox = this.$t("home.searchBook");
      } else if (value == "InsideAllBooks") {
        this.SectionOne.PlaceHoldeTextBox = this.$t("home.searchBooksInsde");
      } else {
        this.SectionOne.PlaceHoldeTextBox = this.$t("home.checkSearchMethot");
      }
    },
    GetCategries(KeySearch) {
      let APISearchType = "/guest/category";
      if (KeySearch == "") {
        APISearchType = "/guest/categorytree";
      }
      this.$store
        .dispatch(
          "GetFromAPI",
          APISearchType + "?filter[categoryname]=" + KeySearch
        )
        .then((response) => {
          this.CategoriesTree = response["data"]["data"];
          this.$nextTick(() => {
            this.SectionOne.SelectedCategory = this.CategoriesTree[0];
            this.GetBooks(
              "filter[categories.categoryid]=" +
              this.SectionOne.SelectedCategory.categoryid +
              "&sort=" +
              this.SectionTwo.SortBy,
              "NewData"
            );
          });
        });
    },
    GetBooks(filterQuery, getType = "NewData", column = 2) {
      // getType : 1 - NewData -> loading form new Categor , 2 LoadMore -> Load More Data
      var filterQueryPage = "";
      if (column == 2) {
        filterQueryPage = "&page=" + this.SectionTwo.PageCount;
      } else if (column == 3) {
        filterQueryPage = "&page=" + this.SectionThree.PageCount;
      }
      this.$store
        .dispatch("GetFromAPI", "/guest/book?" + filterQuery + filterQueryPage)
        .then((response) => {
          if (getType == "NewData") {
            if (column == 2) {
              this.SectionTwo.BooksList = response["data"]["data"];
            } else if (column == 3) {
              this.SectionThree.BooksList = response["data"]["data"];
            }
          } else if (getType == "LoadMore") {
            if (column == 2) {
              this.SectionTwo.BooksList = this.SectionTwo.BooksList.concat(
                response["data"]["data"]
              );
            } else if (column == 3) {
              this.SectionThree.BooksList = this.SectionThree.BooksList.concat(
                response["data"]["data"]
              );
            }
          }
        });
    },
    LoadMoreBook(column) {
      if (column == 2) {
        var container = this.$el.querySelector("#listBook");
        if (
          container.scrollHeight <=
          Math.ceil(container.scrollTop + container.clientHeight)
        ) {
          this.SectionTwo.PageCount++;

          if (
            this.SectionOne.SwitchModel == "BookName" &&
            this.SectionOne.SearchKey != ""
          ) {
            this.GetBooks(
              "filter[bookname]=" +
              this.SectionOne.SearchKey +
              "&sort=" +
              this.SectionTwo.SortBy,
              "LoadMore"
            );
          } else if (this.SectionThree.SwitchModel == "BookMeta") {
            this.GetBooks(
              "filter[bookdsecription]=" +
              this.SectionThree.SearchKey +
              "&sort=" +
              this.SectionTwo.SortBy,
              "LoadMore"
            );
          } else {
            this.GetBooks(
              "filter[categories.categoryid]=" +
              this.SectionOne.SelectedCategory.categoryid +
              "&sort=" +
              this.SectionTwo.SortBy,
              "LoadMore"
            );
          }
        }
      } else if (column == 3) {
        var containerAuther = this.$el.querySelector("#listBookAuther");
        if (
          containerAuther.scrollHeight <=
          Math.ceil(containerAuther.scrollTop + containerAuther.clientHeight)


        ) {
          this.SectionThree.PageCount++;
          this.GetBooks(
            "filter[author.authorname]=" +
            this.BookInformation.author[0]["authorname"],
            "LoadMore",
            3
          );
        }
      }
    },
    SectionTwoSearch() {
      // if (this.timer) {
      //   clearTimeout(this.timer);
      //   this.timer = null;
      // }
      // this.timer = setTimeout(() => {
      if (this.SectionTwo.SwitchModel == "BooksInCategory") {
        this.SectionTwo.PageCount = 1;
        this.SectionTwo.BooksList = [];
        this.GetBooks(
          "filter[categories.categoryid]=" +
          this.SectionOne.SelectedCategory.categoryid +
          "&filter[bookname]=" +
          this.SectionTwo.SearchKey,
          "NewData"
        );
      } else if (this.SectionTwo.SwitchModel == "InsideCategory") {
        if (this.SectionTwo.SearchKey.length < 4) {
          this.$store.dispatch("PushErrorMsg", this.$t('valid.fourChar'))

          return
        }
        this.$router.push({
          name: "SearchBookInside",
          query: { kay: this.SectionTwo.SearchKey, category_id: this.SectionOne.SelectedCategory.categoryid }
        });
      }
      // }, 500);
    },
    SectionTwoChangeSearchMethod() {
      if (this.SectionTwo.SwitchModel == "BooksInCategory") {
        this.SectionOne.SwitchModel = "Categories";
        this.SectionOne.PlaceHoldeTextBox = this.$t("home.searchACategories");

        this.SectionTwo.PlaceHoldeTextBox = this.$t("home.serchBookCategory");
      } else {
        this.SectionTwo.SearchKey = "";
        this.SectionTwo.PlaceHoldeTextBox = this.$t("home.checkSearchMethot");
      }
    },
    SortBooks() {
      this.SectionTwo.PageCount = 1;
      this.GetBooks(
        "filter[categories.categoryid]=" +
        this.SectionOne.SelectedCategory.categoryid +
        "&filter[bookname]=" +
        this.SectionTwo.SearchKey +
        "&sort=" +
        this.SectionTwo.SortBy,
        "NewData"
      );
    },
    GetBookInfo(item) {
      this.$store
        .dispatch("GetFromAPI", "/guest/book/" + item.bookid)
        .then((response) => {
          this.BookInformation = response["data"]["data"];
          this.dialogData.bookId = this.BookInformation.bookid;
          this.SectionThree.PageCount = 1;
          this.$nextTick(() => {
            if (this.clicks == 2) {
              this.dialog = true;
            }
            this.GetBooksByAuther(this.BookInformation);
          });
        });
    },
    ClickBookItem(item) {
      this.selectetBook = item;

      // this.BookInformation.bookid = item.bookid
      this.clicks++;

      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        if (this.clicks == 2) {
          this.GetBookInfo(item);
          this.dialog = true;
          this.clicks = 0;
        } else {
          this.GetBookInfo(item);
        }
        this.clicks = 0;
      }, 250);
    },
    SectionThreeChangeSearchMethod() {
      if (this.SectionThree.SwitchModel == "BookMeta") {
        this.SectionThree.PlaceHoldeTextBox = this.$t("home.serchBooksMeta");
      } else {
        this.SectionThree.PlaceHoldeTextBox = this.$t("home.checkSearchMethot");
        this.SectionThree.SearchKey = "";
      }
    },

    SectionThreeSearch() {
      // if (this.timer) {
      //   clearTimeout(this.timer);
      //   this.timer = null;
      // }
      // this.timer = setTimeout(() => {
      if (this.SectionThree.SwitchModel == 'BookMeta') {
        this.SectionTwo.PageCount = 1;
        this.SectionTwo.BooksList = [];
        this.GetBooks(
          "filter[bookdsecription]=" + this.SectionThree.SearchKey,
          "NewData"
        );
      } else if (this.SectionThree.SwitchModel == 'InsideAllBooksAuther') {
        if (this.SectionThree.SearchKey.length < 4) {
          this.$store.dispatch("PushErrorMsg", this.$t('valid.fourChar'))

          return
        }
        this.$router.push({
          name: "SearchBookInside",
          query: { kay: this.SectionThree.SearchKey, auther_id: this.SectionOne.SelectedCategory.categoryid }// 555555
        });
      } else if (this.SectionThree.SwitchModel == 'InsideThisBook') {
        this.$router.push({
          name: "SearchBookInside",
          query: { kay: this.SectionThree.SearchKey, book_id: this.BookInformation.bookid }// 555555
        });
      }
      // }, 500);
    },
    downloadBook(selectedBookFromList) {
      axios({
        url: selectedBookFromList.fileurl,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        
        let DataForm = {
          API : `/guest/book/${selectedBookFromList.bookid}/download`
        }
        this.$store.dispatch("PostToAPI", DataForm)
        
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", selectedBookFromList.bookname + ".epub");
        document.body.appendChild(link);
        link.click();
      });
    },
    GetBooksByAuther(item) {
      this.SectionThree.BooksList = [];
      this.GetBooks(
        "filter[author.authorname]=" + item.author[0]["authorname"],
        "NewData",
        3
      );
    },
    readQuran() {
      this.$router.push({
        name: "ReadBook",
        params: { bookID: 25416 },
      });
    },
    getBookCount() {
      this.$store
        .dispatch("GetFromAPI", "/guest/statistic/book")
        .then((response) => {
          this.AllBookCount = response["data"]["data"]["total_books_count"];
        });
    },
  },
};
</script>